module.exports = __webpack_public_path__ + "static/media/unica_tortillas.ddc476c0.png";